import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';

const GET_DEVICE_DETAILS_SCHEMA = z.object({
  uuid: z.string(),
  display_name: z.string(),
  created_time: z.string(),
  store_code: z.string(),
  location_id: z.string().optional().nullable(),
  sim_card_id: z.string().optional().nullable(),
  organisations: z.string().array(),
  is_live: z.boolean(),
  start_time: z.string().optional(),
  end_time: z.string().optional(),
  timezone: z.string().optional(),
  scrubber_config: z.object({
    uuid: z.string(),
    min_female_confidence: z.number(),
    min_male_confidence: z.number(),
    inverse_age_bleed_rate: z.number(),
    inverse_age_bleed_middle_age: z.number(),
    gender_body_conf: z.number(),
    object_track_score_thresh: z.number(),
  }),
  generation: z.string().nullable().optional(),
  maintenance_tasks: z
    .object({
      uuid: z.string(),
      wifi_details_update: z.boolean(),
      streaming_mode: z.boolean().optional(),
      reboot: z.boolean().optional(),
      restart_services: z.boolean().optional(),
      upload_application_logs: z.boolean().optional(),
      network_test: z.boolean().optional(),
      set_sim_priority: z.boolean().optional(),
      set_wifi_priority: z.boolean().optional(),
      free_disk_space: z.boolean().optional(),
    })
    .nullable(),
});

export type GetDeviceDetailsResponse = z.infer<typeof GET_DEVICE_DETAILS_SCHEMA>;

export const getDeviceDetailsPromise = async (deviceId: string) => {
  try {
    const headers = getHeadersWithBearerToken();

    const response = await ky
      .get(`${ENV.API_URL}/api/displays/${deviceId}`, {
        headers,
      })
      .json();
    const res = GET_DEVICE_DETAILS_SCHEMA.safeParse(response);

    if (!res.success) {
      console.log('🚀 ~ getDeviceDetailsPromise ~ res.error.message:', res.error.message);
      throw new Error(res.error.message);
    }

    return res.data;
  } catch (error) {
    console.error('Error fetching device details:', error);
    return null;
  }
};
